<template>
  <v-container>
    <v-form @submit.prevent="submit" ref="form">
      <v-text-field
        label="이전 비밀번호"
        v-model="form.passwordConfirm"
        :rules="[rules.required, rules.minLength]"
        :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="show = !show"
        :type="show ? 'text' : 'password'"
      ></v-text-field>
      <v-text-field
        label="새 비밀번호"
        v-model="form.password"
        :rules="[rules.required, rules.minLength]"
        :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="show = !show"
        :type="show ? 'text' : 'password'"
      ></v-text-field>
      <v-text-field
        label="새 비밀번호 확인"
        :rules="[rules.passwordConfirm]"
        :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="show = !show"
        :type="show ? 'text' : 'password'"
      ></v-text-field>
      <v-btn type="submit" color="success" :loading="loading" :disabled="loading">변경</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import { updatePassword } from '@/api'

export default {
  data () {
    return {
      show: false,
      loading: false,
      form: {
        passwordConfirm: '',
        password: ''
      },
      rules: {
        required: v => !!v || '필수 입력 사항 입니다.',
        minLength: v => v.length >= 6 || '적어도 6글자 이상 입력해주세요.',
        passwordConfirm: v => v === this.form.password || '비밀번호가 다릅니다.'
      }
    }
  },
  methods: {
    async submit () {
      if (!this.$refs.form.validate()) return
      if (this.loading) return
      this.loading = true
      try {
        await updatePassword(this.form.passwordConfirm, this.form.password)
        alert('성공')
        this.$router.go(-1)
      } catch (err) {
        alert(err.message)
      }

      this.loading = false
    }
  }
}
</script>
